import * as React from 'react';
export const ColumnMenuContext = React.createContext({
    columns: [],
    visibleColumns: [],
    onColumnToggle: () => {},
    onLock: () => {}
});